import { PlusIcon, Trash2 } from 'lucide-react'
import { Button } from '@neo/primitives/button'
import type { GenericFormType } from '@neo/blocks/forms/types'
import { FieldsRenderer } from '@neo/blocks/forms/fields-renderer'
import type z from 'zod'
import { Tooltip } from '@neo/primitives/tooltip'
import type { AiAgentNodeformData, Intent } from '../../types'
import { intentsSchema, nodeConfigSchema } from '../../config/validation.config'
import { IntentForm } from './intent-form'
import { intentInitialState } from '../../config/nodes.config'

export const NodeConfigs = ({ form }: { form: GenericFormType<AiAgentNodeformData> }) => (
  <div className="w-full max-w-2xl mx-auto">
    <FieldsRenderer
      baseName="node_config"
      fields={[
        {
          name: 'node_config.intents',
          type: 'array',
          defaultNewValue: intentInitialState(),
          className: 'relative',
          removeItemButton: (
            <Tooltip content="Remove intent">
              <Button variant="ghostDestructive" className="absolute right-2 top-2" type="button">
                <Trash2 size={16} />
              </Button>
            </Tooltip>
          ),
          addItemButton: (props) => (
            <div>
              <Button
                className="flex items-center mt-4 form-button"
                variant="ghost"
                type="button"
                {...props}
              >
                <PlusIcon className="h-4 w-4 mr-2" />
                Add Intents
              </Button>
            </div>
          ),
          subFields: [
            {
              name: '',
              type: 'sub-item',
              onChangeListenTo: ['node_config.intents'],
              component: (props) => {
                const hasDuplicateIntentName = nodeConfigSchema
                  .safeParse(props.form.state.values.node_config)
                  .error?.issues?.find((error) => error.message.includes('Duplicate'))
                return (
                  <IntentForm
                    {...(props as {
                      value: Intent
                      onChange: (value: Intent) => void
                      arrayIndex: number
                    })}
                    hasDuplicateIntentName={hasDuplicateIntentName as z.IssueData}
                  />
                )
              },
              zodValidation: intentsSchema,
              eventDataExtractor: (data) => data as Record<string, unknown>,
            },
          ],
        },
      ]}
      form={form}
    />
  </div>
)
